import React, { Fragment, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getResourcePath, trans } from '@spotahome/soyuz/client';

import './PreFilterItem.scss';

const PreFilterItem = ({ id, onChange, checked }) => {
  const preFilter = useRef();

  useEffect(() => {
    preFilter.current.style.setProperty(
      '--prefilter-image',
      `url(${getResourcePath(`/images/prefilters/${id}.webp`)})`
    );
    preFilter.current.style.setProperty(
      '--prefilter-image-jpg',
      `url(${getResourcePath(`/images/prefilters/${id}.jpg`)})`
    );
  }, [id]);

  return (
    <Fragment>
      <input
        className="pre-filter-item__checkbox"
        type="checkbox"
        name={id}
        id={id}
        onChange={onChange}
        checked={checked}
      />
      <label className="pre-filter-item__label" htmlFor={id} ref={preFilter}>
        <span className="pre-filter-item__label-text">
          {trans(`search.prefilters.${id}.title.short`)}
        </span>
      </label>
    </Fragment>
  );
};

PreFilterItem.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};

export default PreFilterItem;
